export const isDoNotSellEnabled = () => !!globalThis.window?.REDUX_HYDRATE?.config?.doNotSell;

const cache = new Set<string>();

export const lazyLoadPixel = (injectPixel: () => void) => {
  if (document.readyState === 'complete') {
    injectPixel();
  } else {
    window.addEventListener('load', injectPixel);
  }
};

export const injectPixel = (src: string) => {
  if (cache.has(src) || isDoNotSellEnabled()) {
    return;
  }

  cache.add(src);

  const loadPixel = () => {
    const script = document.createElement('script');
    script.defer = true;
    script.src = src;
    document.body.appendChild(script);
  };

  lazyLoadPixel(loadPixel);
};
